import { Box, Progress, Text } from "@chakra-ui/react";
import { t } from "i18next";
import { IncompleteFileUploadStatus } from "./FileRow";

export const ProgressBar = ({ status }: { status: IncompleteFileUploadStatus }) => {
  const progressMap: { [key in IncompleteFileUploadStatus]: { text: string; value: number; color: string } } = {
    [IncompleteFileUploadStatus.UploadFailed]: { text: t("Upload failed!"), value: 0, color: "red" },
    [IncompleteFileUploadStatus.UploadingToBrowser]: {
      text: t("Uploading") + "...",
      value: 34,
      color: "teal",
    },
    [IncompleteFileUploadStatus.UploadingToServer]: {
      text: t("Scanning file") + "...",
      value: 64,
      color: "teal",
    },
  };

  return (
    <Box py="1">
      <Progress value={progressMap[status].value} colorScheme={progressMap[status].color} rounded="md" />
      <Text fontWeight={"bold"} fontSize="sm" pt="1">
        {progressMap[status].text}
      </Text>
    </Box>
  );
};
